module.exports = __webpack_public_path__ + "static/media/logo-sm-light.2887ae26.png";